import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {DeviceParamLirisV3TriggerData} from "../../../../../../shared/classes/device/type-v3/device-param-liris-v3-trigger-data";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-param-trigger-data',
    templateUrl: './param-trigger-data.component.html',
    styleUrls: ['./param-trigger-data.component.css']
})
export class ParamTriggerDataComponent implements OnInit {


    public currentTriggerDataIndexForEdition: number = null;

    public triggerDataForm: FormGroup;
    public showTriggerDataForm: boolean = false;

    @Input('deviceParamLirisV3TriggerDataArray') deviceParamLirisV3TriggerDataArray: DeviceParamLirisV3TriggerData[];
    @Input('modeName') modeName: string = "";
    @Input('editable') editable: boolean = true;
    @Input('sensorType') sensorType: number = 6;
    @Input('axeInclino') axeInclino: number = 0;

    constructor(private toastr: ToastrService,
                private translate: TranslateService) {
    }

    ngOnInit() {
        this.initTriggerDataForm();
    }

    setEditable() {

        this.initTriggerDataForm();
        this.showTriggerDataForm = true;
    }

    getChannelValue(){
        if(this.axeInclino === undefined) return 0;
        return this.axeInclino === 2 ? 0 : this.axeInclino;
    }

    initTriggerDataForm() {
        this.showTriggerDataForm = false;
        this.triggerDataForm = new FormGroup({
            timeOrThreshold: new FormControl('', [Validators.required]),
            activated: new FormControl(true),
            channel: new FormControl(this.getChannelValue(), [Validators.required]),
            amplOrHyst: new FormControl('', [Validators.required]),
            preTrigger: new FormControl('', [Validators.required]),
            postTrigger: new FormControl('', [Validators.required]),
            effect: new FormControl('', [Validators.required]),
        });
    }

    addTriggerData() {
        let amp = new DeviceParamLirisV3TriggerData();
        if (this.triggerDataForm.valid) {
            amp.timeOrThreshold = this.triggerDataForm.value.timeOrThreshold;
            amp.activated = this.triggerDataForm.value.activated;
            amp.channel = this.triggerDataForm.value.channel;
            amp.amplOrHyst = this.triggerDataForm.value.amplOrHyst;
            amp.preTrigger = this.triggerDataForm.value.preTrigger;
            amp.postTrigger = this.triggerDataForm.value.postTrigger;
            amp.effect = this.triggerDataForm.value.effect;

            this.toastr.success(this.modeName + ' added', this.translate.instant('SUCCESS'));
            this.deviceParamLirisV3TriggerDataArray.push(amp);
            this.initTriggerDataForm();

        } else {
            this.toastr.error('fill all fields !', this.translate.instant('SUCCESS'));
        }
    }

    editTriggerData() {
        if (this.triggerDataForm.valid) {
            let i = this.currentTriggerDataIndexForEdition;
            this.deviceParamLirisV3TriggerDataArray[i].timeOrThreshold = this.triggerDataForm.value.timeOrThreshold;
            this.deviceParamLirisV3TriggerDataArray[i].activated = this.triggerDataForm.value.activated;
            this.deviceParamLirisV3TriggerDataArray[i].channel = this.triggerDataForm.value.channel;
            this.deviceParamLirisV3TriggerDataArray[i].amplOrHyst = this.triggerDataForm.value.amplOrHyst;
            this.deviceParamLirisV3TriggerDataArray[i].preTrigger = this.triggerDataForm.value.preTrigger;
            this.deviceParamLirisV3TriggerDataArray[i].postTrigger = this.triggerDataForm.value.postTrigger;
            this.deviceParamLirisV3TriggerDataArray[i].effect = this.triggerDataForm.value.effect;

            this.toastr.success(this.modeName + ' #' + this.currentTriggerDataIndexForEdition + ' modified', this.translate.instant('SUCCESS'));
            this.currentTriggerDataIndexForEdition = null;
            this.initTriggerDataForm();

        } else {
            this.toastr.error('fill all fields !', this.translate.instant('ERROR'));
        }
    }

    setFormWithTriggerData(i: number) {

        this.initTriggerDataForm();
        this.showTriggerDataForm = true;
        this.currentTriggerDataIndexForEdition = i;
        this.triggerDataForm.setValue({
            timeOrThreshold: this.deviceParamLirisV3TriggerDataArray[i].timeOrThreshold,
            activated: this.deviceParamLirisV3TriggerDataArray[i].activated,
            channel: this.deviceParamLirisV3TriggerDataArray[i].channel,
            amplOrHyst: this.deviceParamLirisV3TriggerDataArray[i].amplOrHyst,
            preTrigger: this.deviceParamLirisV3TriggerDataArray[i].preTrigger,
            postTrigger: this.deviceParamLirisV3TriggerDataArray[i].postTrigger,
            effect: this.deviceParamLirisV3TriggerDataArray[i].effect
        });
        this.toastr.success('You can now edit ' + this.modeName.toLowerCase() + ' #' + this.currentTriggerDataIndexForEdition, this.translate.instant('SUCCESS'));
    }

    cancelTriggerData() {
        this.currentTriggerDataIndexForEdition = null;
        this.initTriggerDataForm();

    }

    removeTriggerData(i: number) {
        this.deviceParamLirisV3TriggerDataArray.splice(i, 1);
        this.toastr.warning(this.modeName + ' #' + i + ' removed', this.translate.instant('SUCCESS'));
    }

}
